
const activeMenu = {
    state: {
        //首页导航栏
        mainIndex: '/main/index',
        //个人中心导航栏
        profileIndex: '/profile/grzl',
    },
    mutations: {
        SET_MAININDEX:(state, index) => {
            state.mainIndex = index;
        },
        SET_PROFILEINDEX:(state, index) => {
            state.profileIndex = index;
        },
    },
}
export default activeMenu;
